import { Landing } from '../pages/Landing';
import { Onboarding } from '../pages/Onboarding';
import { landingAnchorRoutes } from './landingAnchorRoutes';
import { NewsDetailPage } from '../pages/NewsDetail';
import { Information } from '../pages/Information';
import { Registration } from '../pages/Registration';


export const routes = {
    home: {
        route: '/',
        page: Landing,
        anchors: landingAnchorRoutes,
    },
    onboarding: {
        route: '/onboarding',
        name: 'Регистрация',
        page: Onboarding,
        isRed: true,
    },
    newsdetail: {
        route: '/news/:id',
        name: 'Новость',
        page: NewsDetailPage,
    },
    registration: {
        route: '/registration',
        name: 'Регистрация',
        page: Registration,
    },
    information: {
        route: '/information',
        name: 'Раскрытие информации',
        page: Information,
    },
};

export const headerRoutes = [
    'issuers',
    'investors',
    'partners',
    'news',
    'registration',
    'documents',
    'contacts',
];

export const footerRoutes = [[], [], [], []];
